import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId")({
	component: Outlet,
})
